"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusColors = exports.getCreditBadgeOptions = exports.getIconMappings = exports.convertHexToRGBA = exports.lightenDarkenColor = void 0;
const react_1 = __importDefault(require("react"));
const color_1 = __importDefault(require("color"));
const Icon_1 = __importStar(require("../components/Icon/Icon"));
function lightenDarkenColor(hex, amt) {
    const colorHex = (0, color_1.default)(hex);
    const color = amt > 0 ? colorHex.lighten(Math.abs(amt)) : colorHex.darken(Math.abs(amt));
    return color.hex();
}
exports.lightenDarkenColor = lightenDarkenColor;
const convertHexToRGBA = (hexCode) => {
    let hex = hexCode.replace('#', '');
    if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgb(${r}, ${g}, ${b})`;
};
exports.convertHexToRGBA = convertHexToRGBA;
function getIconMappings() {
    return Object.keys(Icon_1.Icons).reduce((mapping, iconName) => (Object.assign(Object.assign({}, mapping), { [iconName]: react_1.default.createElement(Icon_1.default, { icon: iconName }) })), {});
}
exports.getIconMappings = getIconMappings;
function getCreditBadgeOptions() {
    return ['A', 'B', 'C', 'D', 'F', 'I', 'N'];
}
exports.getCreditBadgeOptions = getCreditBadgeOptions;
function getStatusColors() {
    return ['red', 'green', 'yellow', 'blue'];
}
exports.getStatusColors = getStatusColors;
//# sourceMappingURL=index.js.map